import { Card, CardStatusEnum, CardTypeEnum } from '@varo/graphql-schema-types';
import { useFetchCards } from 'shared/hooks/useFetchCards/useFetchCards';
import { isNotNil } from 'shared/utils/isNotNil/isNotNil';
import { RequestPolicy } from 'urql';

export const useFetchCardsWithLockStatus = (props?: {
  pause?: boolean;
  believeOnly?: boolean;
  requestPolicy?: RequestPolicy;
}) => {
  const {
    requestPolicy = 'cache-and-network',
    believeOnly = false,
    pause = false,
  } = props || {};
  const {
    data: cardsData,
    error: cardsError,
    fetching: cardsFetching,
    refetch: refetchCards,
  } = useFetchCards({ requestPolicy, pause });

  const { cards } = cardsData ?? {};

  const believePredicate = (card: Card) =>
    believeOnly ? card.type === CardTypeEnum.ChargeCard : true;

  const availableCards = cards?.filter(
    (card) =>
      (card.isLocked || card.status === CardStatusEnum.Activated) &&
      believePredicate(card),
  );

  const isDebitLocked = cards?.find(
    (card) => card.type === CardTypeEnum.DebitCard,
  )?.isLocked;
  const isBelieveLocked = cards?.find(
    (card) => card.type === CardTypeEnum.ChargeCard,
  )?.isLocked;

  const hasLockedCards = availableCards?.some((card) => card?.isLocked);
  const hasCards: boolean = (availableCards?.length ?? 0) > 0;

  return {
    hasCards,
    hasLockedCards,
    analyticsMetadata: {
      isDebitLocked: isNotNil(isDebitLocked)
        ? isDebitLocked.toString()
        : 'none',
      isBelieveLocked: isNotNil(isBelieveLocked)
        ? isBelieveLocked.toString()
        : 'none',
    },
    cards: availableCards,
    cardsError,
    cardsFetching,
    refetchCards,
  };
};
